import { AlertTriangle, CheckCircle, Clock } from 'lucide-react';

import { cn } from '@/lib/utils';

type IncidentStatus = 'triggered' | 'acknowledged' | 'resolved';

interface IncidentStatusProps {
  sourceStatus: IncidentStatus;
  className?: string;
}

const sourceStatusConfig = {
  triggered: {
    label: 'Triggered',
    icon: AlertTriangle,
    bgColor: 'bg-red-100 dark:bg-red-900/30',
    textColor: 'text-red-800 dark:text-red-200',
    iconColor: 'text-red-600 dark:text-red-400',
    borderColor: 'border-red-200 dark:border-red-700',
  },
  acknowledged: {
    label: 'Acknowledged',
    icon: Clock,
    bgColor: 'bg-yellow-100 dark:bg-yellow-900/30',
    textColor: 'text-yellow-800 dark:text-yellow-200',
    iconColor: 'text-yellow-600 dark:text-yellow-400',
    borderColor: 'border-yellow-200 dark:border-yellow-700',
  },
  resolved: {
    label: 'Resolved',
    icon: CheckCircle,
    bgColor: 'bg-green-100 dark:bg-green-900/30',
    textColor: 'text-green-800 dark:text-green-200',
    iconColor: 'text-green-600 dark:text-green-400',
    borderColor: 'border-green-200 dark:border-green-700',
  },
} as const;

export const IncidentStatusBadge = ({
  sourceStatus,
  className,
}: IncidentStatusProps): JSX.Element => {
  const sourceConfig =
    sourceStatus in sourceStatusConfig
      ? sourceStatusConfig[sourceStatus]
      : sourceStatusConfig.triggered;
  const Icon = sourceConfig.icon;

  return (
    <div className={cn('flex flex-col gap-1')}>
      <div
        className={cn(
          'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border',
          sourceConfig.bgColor,
          sourceConfig.textColor,
          sourceConfig.borderColor,
          className,
        )}
      >
        <Icon className={cn('w-3 h-3', sourceConfig.iconColor)} />
        {sourceConfig.label}
      </div>
    </div>
  );
};
